// src/features/analysis/slice.js
import { createSlice } from '@reduxjs/toolkit';
import { fetchClusterData } from './analysis.api'; // Import asyncThunks

const initialState = {
  clusterData: null,
  clusterLoading: 'idle', // 'idle' | 'pending' | 'succeeded' | 'failed'
  clusterError: null,
  // ... other state properties for other analysis data
};

const analysisSlice = createSlice({
  name: 'analysis',
  initialState,
  reducers: {
    // ... your other reducers for the analysis slice (if any)
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchClusterData.pending, (state) => {
        state.clusterLoading = 'pending';
        state.clusterError = null;
      })
      .addCase(fetchClusterData.fulfilled, (state, action) => {
        state.clusterLoading = 'succeeded';
        state.clusterData = action.payload;
      })
      .addCase(fetchClusterData.rejected, (state, action) => {
        state.clusterLoading = 'failed';
        state.clusterError = action.payload; // Error message
      });
    // ... add cases for other asyncThunks
  },
});

export default analysisSlice.reducer;